export default __webpack_public_path__ + "static/media/Create-documentation.671fb716.md";